<template>
  <va-create-layout>
    <amendments-form :title="title" :item="item"></amendments-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ['title', 'item'],
}
</script>
